import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export type AiQuoteFeature = "improve" | "translate";

export type AiQuote = {
  feature: AiQuoteFeature;
  tokensIn: number;
  tokensOut: number;
  points: number;
  costFcfa: number;
  balance: number;
  affordable: boolean;
};

type AiQuotePayload = {
  feature: AiQuoteFeature;
  resume?: Record<string, unknown>;
  text?: string;
  language?: string;
};

export const requestAiQuote = async ({ feature, resume, text, language }: AiQuotePayload) => {
  const response = await axios.post<AiQuote>("/ai/quote", {
    feature,
    resume: resume ? JSON.stringify(resume) : undefined,
    text: text?.trim() || undefined,
    language,
  });

  return response.data;
};

export const useAiQuote = () =>
  useMutation({
    mutationFn: requestAiQuote,
  });
